import axios from "axios"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { CityAddRevenue, CityArrayAdd, CityFromAddUserAdd, ClearSelectedCity, SelectCity } from "../../Reducer/CitySlice"
import { StaffArrayAdd, StaffHours, StaffOneDaySumHours, StaffSelectedCityArrayAdd, setHoursStaff, setStaffAllMonth } from "../../Reducer/StaffSlice"
import { setAllMonthRavenue, setPercentCity, setRevenueArray } from "../../Reducer/RevenueSlice"
import { ClearSelectedMonth, MonthArrayAdd, SelectMonth, changeBlockEditSelectedMonth, setWeekDay } from "../../Reducer/MonthSlice"
import { setOpenChoicePeriod, setOpenDeletedStaff, setOpenLogin, setOpenMainMenu, setOpenModalAddCity, setOpenModalAddStaff, setOpenModalAddUser, setOpenOptionMenu, setOpenRevenue, setOpenUserManagment, TransitionSystem } from "../../Reducer/ModalSlice"
import { FaRegTrashAlt , FaSyncAlt } from "react-icons/fa"
import { setPeriod } from "../../Reducer/PeriodSlice"
import { FaPencil, FaRegCalendar, FaStore, FaUserTie, FaUser, FaUserXmark, FaLockOpen, FaLock, FaCheck } from "react-icons/fa6";
import { addUsers } from "../../Reducer/UserSlice"
import { roleId } from "../Constants/app"
import Select from 'react-select';

function MainMenu(){
    const AllMonthRavenue = useSelector(state => state.RevenueSlice.AllMonthRavenue)

    const CityArray = useSelector(state => state.CitySlice.CityArray)
    const SelectedCity = useSelector(state => state.CitySlice.SelectedCity)
    
    const StaffArray = useSelector(state => state.StaffSlice.StaffArray)
    const StaffAllMonth = useSelector(state => state.StaffSlice.StaffAllMonth)    
    
    const SelectedMonth = useSelector(state => state.MonthSlice.SelectedMonth)
    const MonthArray = useSelector(state => state.MonthSlice.MonthArray)
    
    const User = useSelector(state => state.UserSlice.User)
    const Server = useSelector(state => state.UserSlice.Server)

    const OpenOptionMenu = useSelector(state => state.ModalSlice.OpenModal.OpenOptionMenu)
    
    const [ModalDeleteCity, setModalDeleteCity] = useState(false)
    const [ModalDeleteMonth, setModalDeleteMonth] = useState(false)
    const [isLoadingLocker, setLoadingLocker] = useState(true)
    const [isLoading, setLoading] = useState(true)
    const [SuscessLoading, setSuscessLoading] = useState(false)
    
    const dispatch = useDispatch()
 
    const handleBlockEdit = (event) => {
        if(![roleId.admin, roleId.operatingDirector].includes(User.user.role.id))
            return(
                alert('У вас нет прав для данного действия')
            )

        setLoadingLocker(false)        
        axios.put(Server + 'months/' + SelectedMonth.id, {
            BlockEdit: !SelectedMonth.BlockEdit
        }, {
            headers: {
            Authorization: 'Bearer ' + User.jwt,
            },
        })
        .then(() => {
            dispatch(changeBlockEditSelectedMonth(!SelectedMonth.BlockEdit))
        })
        .catch(() => {
            alert('Произошла ошибка сохранения, поваторите попытку')
        })
        .finally(() => {
            setLoadingLocker(true)
        })
    }

    const handleClickButtonViewMonth = () => {
        if(parseInt(new Date(SelectedCity.created_at).getMonth() + 1) <= parseInt(SelectedMonth.MonthValue) || parseInt(new Date(SelectedCity.created_at).getFullYear()) < parseInt(SelectedMonth.YearValue))
            {
            var RevenuePushed = []
            var PercentPushed = []
            AllMonthRavenue.map((item) => {
                if(SelectedMonth.YearValue === item.YearValue && SelectedMonth.MonthValue === item.MonthValue && SelectedCity.id === item.idCity)
                {
                dispatch(CityAddRevenue({idCity: SelectedCity.id, idRevenue: item.id, Revenue: item.Revenue, Percent: item.Percent}))
                

                var filteredRevenue = item.Revenue
                var filteredPercentCity = item.Percent
                filteredPercentCity = filteredPercentCity.split('_')
                filteredRevenue = filteredRevenue.split('_')
                
                filteredRevenue.map((a, index) => {
                    RevenuePushed.push({id: (parseInt(index)), Value: a})
                    return(a)
                })

                filteredPercentCity.map((a) => {
                    PercentPushed.push(a)
                    return(a)
                })
                
                dispatch(setRevenueArray(RevenuePushed))
                document.documentElement.style.setProperty('--widthFirstStaffPostDiv', '1230px');
                var StaffPostWidthCheck = parseInt(RevenuePushed.length) - 15
                StaffPostWidthCheck = (StaffPostWidthCheck * 82) 
                StaffPostWidthCheck = StaffPostWidthCheck + 'px'
                document.documentElement.style.setProperty('--widthSecondStaffPostDiv', StaffPostWidthCheck);

                var StaffGlobalDivWidthcCheck = parseInt(RevenuePushed.length)
                StaffGlobalDivWidthcCheck = (StaffGlobalDivWidthcCheck * 82) + 2032 + 10
                StaffGlobalDivWidthcCheck = StaffGlobalDivWidthcCheck + 'px'
                document.documentElement.style.setProperty('--widthStaffGlobalDiv', StaffGlobalDivWidthcCheck);
                dispatch(setPercentCity(PercentPushed))
                const staffCity = StaffArray.filter((a) => {
                    if (a.idCity !== SelectedCity.id) return false;
                    const month = parseInt(new Date(a.created_at).getMonth() + 1);
                    const year = parseInt(new Date(a.created_at).getFullYear());
                    if (year > parseInt(SelectedMonth.YearValue)) return false;
                    if (month > parseInt(SelectedMonth.MonthValue) && year === parseInt(SelectedMonth.YearValue)) return false;
                    return true
                })
                dispatch(StaffSelectedCityArrayAdd(staffCity))
                StaffArray.map((a) => {
                    StaffAllMonth.map((itemStaff) => {
                    if(itemStaff.YearValue === SelectedMonth.YearValue && itemStaff.MonthValue === SelectedMonth.MonthValue && a.id === itemStaff.idStaff)
                    dispatch(setHoursStaff({idHourses: itemStaff.id, idStaff: itemStaff.idStaff, Hours: itemStaff.Hours, Additional: itemStaff.Additional, Rate: itemStaff.Rate, Shift: itemStaff.Shift, Prize: itemStaff.Prize, Hidden: itemStaff.Hidden, SecondRate: itemStaff.SecondRate, SecondShift: itemStaff.SecondShift, SecondPrize: itemStaff.SecondPrize}))
                    return(itemStaff)
                    })
                    return(a)
                })
                
                }
                return(item)
            })

            dispatch(StaffHours({MinDay: 1, MaxDay: parseInt(RevenuePushed.length)}))                                        
            
            RevenuePushed.map((a) => {
                if(a.id > -1 && a.id < (RevenuePushed.length))
                dispatch(StaffOneDaySumHours(a.id))
                return(a)
            })
        dispatch(setPeriod({MinDay: 1, MaxDay: parseInt(RevenuePushed.length), PeriodOn: false}))
        dispatch(setOpenMainMenu(false))
        dispatch(setOpenRevenue(true))
        }
        else
        {
            alert('Филиал был создан позже')
        }
    }

    const handleClickButtonChoicePeriod = () => {
        if(parseInt(new Date(SelectedCity.created_at).getMonth() + 1) <= parseInt(SelectedMonth.MonthValue) || parseInt(new Date(SelectedCity.created_at).getFullYear()) < parseInt(SelectedMonth.YearValue))
        {
            dispatch(setOpenChoicePeriod(true))
            dispatch(setOpenMainMenu(false))
        }
        else
        {
            alert('Филиал был создан позже')
        }
    }

    const handleAddMonth = async () => {
        setLoading(false)

        var NewMonthValue = ''
        var NewYearValue = ''
        var NewName = ''
        var Days = ''

        if (MonthArray[0].MonthValue !== 12) {
            NewMonthValue = parseInt(MonthArray[0].MonthValue) + 1;
            NewYearValue = parseInt(MonthArray[0].YearValue);
        } else {
            NewMonthValue = 1;
            NewYearValue = parseInt(MonthArray[0].YearValue) + 1;
        }

        switch (NewMonthValue) {
            case 1: NewName = 'Январь ' + NewYearValue; break;
            case 2: NewName = 'Февраль ' + NewYearValue; break;
            case 3: NewName = 'Март ' + NewYearValue; break;
            case 4: NewName = 'Апрель ' + NewYearValue; break;
            case 5: NewName = 'Май ' + NewYearValue; break;
            case 6: NewName = 'Июнь ' + NewYearValue; break;
            case 7: NewName = 'Июль ' + NewYearValue; break;
            case 8: NewName = 'Август ' + NewYearValue; break;
            case 9: NewName = 'Сентябрь ' + NewYearValue; break;
            case 10: NewName = 'Октябрь ' + NewYearValue; break;
            case 11: NewName = 'Ноябрь ' + NewYearValue; break;
            case 12: NewName = 'Декабрь ' + NewYearValue; break;
            default: break;
        }
            dispatch(setOpenOptionMenu(!OpenOptionMenu))
        
            try {
                await axios.post(Server + 'months', {
                    Name: String(NewName),
                    YearValue: parseInt(NewYearValue),
                    MonthValue: parseInt(NewMonthValue),
                    BlockEdit: false
                }, {
                    headers: { Authorization: 'Bearer ' + User.jwt }
                });
            } catch (error) {
                setSuscessLoading(false);
                alert('Что-то пошло не так, обновите страницу и повторите попытку');
                setLoading(true);
                return;
            }

            const asyncPool = async (tasks, limit) => {
                const results = [];
                const executing = [];
                for (const task of tasks) {
                    const p = Promise.resolve().then(() => task());
                    results.push(p);
                    if (limit <= tasks.length) {
                        const e = p.then(() => executing.splice(executing.indexOf(e), 1));
                        executing.push(e);
                        if (executing.length >= limit) {
                            await Promise.race(executing);
                        }
                    }
                }
                return Promise.all(results);
            };

            if(NewMonthValue === 1 || NewMonthValue === 3 || NewMonthValue === 5 || NewMonthValue === 7 || NewMonthValue === 8 || NewMonthValue === 10 || NewMonthValue === 12) 
                {
                    Days = '0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0'
                }
            else
                {
                    if(NewMonthValue === 2)
                    {
                        if(NewYearValue % 4 === 0 && (NewYearValue % 100 !== 0 || NewYearValue % 400 === 0)) 
                        {
                            Days = '0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0'
                        }
                        else
                        {
                            Days = '0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0'
                        }
                    }
                    else
                    {
                        Days = '0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0'
                    }
                }

            const staffTasks = StaffArray.map(el => async () => {
                var StaffMonthCheck = StaffAllMonth.filter(a => a.idStaff === el.id);
                var newRate = StaffMonthCheck[StaffMonthCheck.length - 1]?.SecondRate || 0;
                var newPrize = StaffMonthCheck[StaffMonthCheck.length - 1]?.SecondPrize || 0;
                var newShift = StaffMonthCheck[StaffMonthCheck.length - 1]?.Shift || 0;
                var HiddenCheck = el.Deleted === 'false' ? false : true;
        
                await axios.post(Server + 'staffofthemonths', {
                    MonthValue: NewMonthValue,
                    YearValue: NewYearValue,
                    Rate: newRate,
                    Prize: newPrize,
                    Shift: newShift,
                    SecondRate: newRate,
                    SecondPrize: newPrize,
                    SecondShift: newShift,
                    Hours: Days,
                    Additional: '0_0_0_0',
                    Hidden: HiddenCheck,
                    idStaff: parseInt(el.id)
                }, {
                    headers: { Authorization: 'Bearer ' + User.jwt }
                });
            });

            const cityTasks = CityArray.map(el => async () => {
                var PercentCheckerArray = AllMonthRavenue.filter(a => a.idCity === el.id);
                var PercentChecker = PercentCheckerArray[PercentCheckerArray.length - 1]?.Percent || 0;
                await axios.post(Server + 'citiesrevenues', {
                    MonthValue: NewMonthValue,
                    YearValue: NewYearValue,
                    Revenue: Days,
                    Percent: PercentChecker,
                    idCity: parseInt(el.id)
                }, {
                    headers: { Authorization: 'Bearer ' + User.jwt }
                });
            });

            const allTasks = [...staffTasks, ...cityTasks];

            try {
                await asyncPool(allTasks, 5); // не более 5 одновременных запросов
                setSuscessLoading(true);
                await getCity();
                setLoading(true);
                setTimeout(() => {
                    setSuscessLoading(false);
                }, 500);
            } catch (error) {
                setSuscessLoading(false);
                alert('Что-то пошло не так, обновите страницу и повторите попытку');
                setLoading(true);
            }  
    }

    const handleDeleteCity = async () => {
        await axios.get(Server + 'staff?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
            params:{
                idCity: parseInt(SelectedCity.id)
            }})
            .then((response) =>{
                axios.get(Server + 'staffofthemonths?_limit=-1', {
                    headers: {
                        Authorization: 'Bearer ' + User.jwt,
                    },
                    params:{
                        idStaff: parseInt(response.data.id)
                    }})
                    .then((res) =>{
                        res.data.map((el) => {
                            return(axios.delete(Server + 'staffofthemonth/' + el.id, {
                                headers: {
                                    Authorization: 'Bearer ' + User.jwt,
                                }
                            }))
                        })
                        
                    })
                response.data.map((el) => {
                    return(
                        axios.delete(Server + 'staff/' + el.id, {
                            headers: {
                                Authorization: 'Bearer ' + User.jwt,
                            }
                        })
                    )
                })       
                
            })
        
        await axios.get(Server + 'citiesrevenues?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
            params:{
                idCity: parseInt(SelectedCity.id)
            }})
            .then((response) =>{
                response.data.map((el) => {
                    return(
                        axios.delete(Server + 'citiesrevenues/' + el.id, {
                            headers: {
                                Authorization: 'Bearer ' + User.jwt,
                            }
                        })
                    )
                })
            })
       
        await axios.get(Server + 'cityadvancereports?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
            params:{
                idCity: parseInt(SelectedCity.id)
            }}) 
            .then((response) =>{
                response.data.map((el) => {
                    return(
                        axios.delete(Server + 'cityadvancereports/' + el.id, {
                            headers: {
                                Authorization: 'Bearer ' + User.jwt,
                            }
                        })
                    )
                })
               
            })                

        await axios.delete(Server + 'cities/' + SelectedCity.id, {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        dispatch(ClearSelectedCity())

        await getCity()
        
        setModalDeleteCity(false)
    }

    const handleDeleteMonth = async () => {
        await axios.get(Server + 'citiesrevenues?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
            params:{
                MonthValue: parseInt(SelectedMonth.MonthValue),
                YearValue: parseInt(SelectedMonth.YearValue),
            }})
            .then((response) =>{
                response.data.map((el) => {
                    return(
                        axios.delete(Server + 'citiesrevenues/' + el.id, {
                            headers: {
                                Authorization: 'Bearer ' + User.jwt,
                            }
                        })
                    )
                })
            })

        await axios.get(Server + 'staffofthemonths?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
            params:{
                MonthValue: parseInt(SelectedMonth.MonthValue),
                YearValue: parseInt(SelectedMonth.YearValue),
            }})
            .then((response) =>{
                response.data.map((el) => {
                    return(
                        axios.delete(Server + 'staffofthemonths/' + el.id, {
                            headers: {
                                Authorization: 'Bearer ' + User.jwt,
                            }
                        })
                    )
                })
            })

        await axios.delete(Server + 'months/' + SelectedMonth.id, {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        dispatch(ClearSelectedMonth())

        await getCity()

        setModalDeleteMonth(false)
    }
    
    const getCity = async () =>  {
        setLoading(false)
        var CityArrayChecked = []
        var CityCheck 
        await axios.get(Server + 'cities?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            }
        })
        .then((response) => {
            if([roleId.admin, roleId.operatingDirector].includes(User.user.role.id) || User.user.idCity === 'all')
            {
                dispatch(CityArrayAdd(response.data))
            }
            else
            {
                CityCheck = response.data
            }
        })

        if(![roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && User.user.idCity !== 'all')
        {
            await User.user.idCity.map((el) => {
                CityCheck.map((a) => {
                    if(parseInt(a.id) === parseInt(el))
                    {
                        CityArrayChecked.push(a)
                    }
                    return(a)
                })
                return(el)
            })
            await dispatch(CityArrayAdd(CityArrayChecked))
        }
  
            
        await axios.get(Server + "staff?_limit=-1", {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            }
        })
        .then((responseStaff) => {

            dispatch(StaffArrayAdd(responseStaff.data))
        });
  
        await axios.get(Server + 'months?_limit=-1&_sort=id:DESC', {
            headers: {
                Authorization:'Bearer ' + User.jwt,
            }
        })
        .then((responseMonth) => {
            dispatch(MonthArrayAdd(responseMonth.data))
        })
  
        await axios.get(Server + 'citiesrevenues?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            }
        })
        .then((responseRevenue) => {
            dispatch(setAllMonthRavenue(responseRevenue.data))
        })
  
        await axios.get(Server + 'staffofthemonths?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            }
        })
        .then((responseStafffAllMonth) => {
            dispatch(setStaffAllMonth(responseStafffAllMonth.data))
        })    
        
        setLoading(true)
    }

    useEffect(() => {
        if(window.matchMedia('(max-width: 740px)').matches)
            dispatch(setOpenOptionMenu(false))      
        getCity()
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])

      if(!isLoading)
        return(
            <div
            className="ModalGlobalDiv"
            >
                <div
                className="BigSpin"
                />
            </div>
        )

    if(SuscessLoading && isLoading)
        return(
            <div
            className="ModalGlobalDiv"
            >
                <div
                className="BigCheckDiv"
                >
                    <FaCheck className="BigCheckIcon"/>
                </div>
            </div>
        )

    const renderAdress = (item) => {
        return item.City + ' ' + item.Adress;
    }

    const handleChangePoint = (value) => {
        dispatch(SelectCity(value));
    }

    const handleChangeMonth = (value) => {
        dispatch(SelectMonth(value));
        var day = new Date(value.YearValue + "-" + value.MonthValue + "-01").getDay();
        dispatch(setWeekDay(day));
    }

    return(
        <div
        className="ModalGlobalDiv"
        >
            <div
            className="MainMenuMainDiv"
            >
                <div
                className="MainMenuDataDiv"
                >
                    <div
                    className="MainMenuColumnDiv"
                    >
                        
                        <div className="DivFlex Gap" style={{ alignItems: 'center' }} >
                            <div style={{ width: '210px' }}>
                                <Select
                                closeMenuOnSelect={true}
                                options={[...CityArray]
                                    .sort((a, b) => {
                                    const adressA = renderAdress(a);
                                    const adressB = renderAdress(b);
                                    if (adressA < adressB) return -1;
                                    if (adressA > adressB) return 1;
                                    return 0;
                                    })
                                    .map(item => ({
                                        value: item,
                                        label: renderAdress(item)
                                    }))}
                                onChange={((e) => handleChangePoint(e.value))}
                                placeholder="Филиал"
                                noOptionsMessage={() => 'Нет филиалов'}
                                value={SelectedCity && SelectedCity.id > 0 ? {value: SelectedCity, label: renderAdress(SelectedCity)} : null}
                                />
                            </div>
                                
                            {SelectedCity.id !== 0 && [roleId.admin].includes(User.user.role.id) && 
                                <button
                                className="FilterButtonAR"
                                onClick={(() => {
                                    setModalDeleteCity(true)
                                })}
                                >
                                    <FaRegTrashAlt/>
                                </button>
                            }
                        </div>
                        
                        
                        <div>
                            <div className="DivFlex Gap" style={{ alignItems: 'center' }}>
                                <div style={{ width: '210px' }}>
                                    <Select
                                    closeMenuOnSelect={true}
                                    options={MonthArray
                                        .map(item => ({
                                            value: item,
                                            label: item.Name
                                        }))}
                                    onChange={((e) => handleChangeMonth(e.value))}
                                    placeholder="Месяц"
                                    noOptionsMessage={() => 'Нет месяцев'}
                                    value={SelectedMonth && SelectedMonth.id > 0 ? {value: SelectedMonth, label: SelectedMonth.Name} : null}
                                    />
                                </div>
                                {SelectedMonth.id !== 0 && 
                                <button
                                className="FilterButtonAR"
                                onClick={handleBlockEdit}
                                >          
                                    {isLoadingLocker 
                                    ? 
                                    SelectedMonth.BlockEdit ? <FaLock /> : <FaLockOpen />
                                    : 
                                    <div
                                    className="MiniSpinLocker"
                                    />
                                    }                            
                                </button>
                                }

                                {SelectedMonth.id !== 0 && [roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && 
                                <button
                                className="FilterButtonAR"
                                onClick={(() => {
                                    setModalDeleteMonth(true)
                                })}
                                >
                                    <FaRegTrashAlt/>
                                </button>
                                }
                            </div>
                        </div>
                        
                        <button
                        className="ButtonMainMenu"
                        onClick={handleClickButtonChoicePeriod}
                        >
                            Выбрать период
                        </button>
                        <button
                        className="ButtonMainMenu"
                        onClick={handleClickButtonViewMonth}
                        >
                            Показать за месяц
                        </button>                        
                    </div>
                </div>
                
                <div
                className={OpenOptionMenu ? "MainMenuOptionsDiv" : "MainMenuOptionsDiv Close"}
                >
                    <div
                    className="MainMenuColumnDiv Options"
                    >
                        {[roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && 
                        <>
                        <button
                        className="ButtonMainMenu Options"
                        onClick={(() => {
                            dispatch(setOpenOptionMenu(false))
                            dispatch(setOpenModalAddCity(true))
                            dispatch(setOpenMainMenu(false))
                        })}
                        >
                           <div className="IconButtonMainMenuDiv"> <FaStore/> </div> Добавить филиал
                        </button>
                        
                        <button
                        className="ButtonMainMenu Options"
                        onClick={(event) => {
                            dispatch(setOpenOptionMenu(false))
                            handleAddMonth(event)
                        }}
                        >
                            <div className="IconButtonMainMenuDiv"><FaRegCalendar/></div> Добавить месяц
                        </button>
                        </>
                        }
                        
                        <button
                        className="ButtonMainMenu Options"
                        onClick={(() => {
                            dispatch(setOpenOptionMenu(false))
                            dispatch(setOpenModalAddStaff(true))
                            dispatch(setOpenMainMenu(false))
                        })}
                        >
                            <div className="IconButtonMainMenuDiv"><FaUser/></div> Добавить сотрудника
                        </button>

                        {[roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && 
                        <>
                        <button
                        className="ButtonMainMenu Options"
                        onClick={(() => {
                            dispatch(setOpenOptionMenu(false))
                            dispatch(setOpenModalAddUser(true))
                            dispatch(CityFromAddUserAdd())
                            dispatch(setOpenMainMenu(false))
                        })}
                        >
                            <div className="IconButtonMainMenuDiv"><FaUserTie/></div> Добавить пользователя
                        </button>

                        <button
                        className="ButtonMainMenu Options"
                        onClick={(async () => {
                            dispatch(CityFromAddUserAdd())
                            await axios.get(Server + "users?_limit=-1", {
                                headers: {
                                    Authorization: 'Bearer ' + User.jwt,
                                }
                            })
                            .then((response) => {
                                var addedUsersArray = response.data.filter(el => el.role.id !== roleId.admin)
                                dispatch(addUsers(addedUsersArray))
                                dispatch(setOpenOptionMenu(false))
                                dispatch(setOpenUserManagment(true))
                                dispatch(setOpenMainMenu(false))
                            });
                        })}
                        >
                            <div className="IconButtonMainMenuDiv"><FaPencil /></div> Пользователи
                        </button>
                        </>
                        }

                        {[roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && 
                        <button
                        className="ButtonMainMenu Options"
                        onClick={(async () => {
                            await axios.get(Server + "staff?_limit=-1", {
                                headers: {
                                    Authorization: 'Bearer ' + User.jwt,
                                }
                            })
                            .then((responseStaff) => {
                                dispatch(StaffArrayAdd(responseStaff.data))
                            })
                            dispatch(setOpenOptionMenu(false))
                            dispatch(setOpenDeletedStaff(true))
                        })}
                        >
                            <div className="IconButtonMainMenuDiv"> <FaUserXmark/> </div> Удаленные сотрудники
                        </button>
                        }


                        <button
                        className="ButtonMainMenu Options BetweenSystems"
                        onClick={(async () => {
                        await dispatch(TransitionSystem())
                        dispatch(ClearSelectedCity())
                        dispatch(ClearSelectedMonth())
                        dispatch(setOpenLogin(false))
                        })}
                        >
                        <div className="IconButtonMainMenuDiv"> <FaSyncAlt /> </div> Выбор модуля
                        </button>
                        
                    </div>
                </div>

                <div className={OpenOptionMenu ? "BlackoutMainMenuOptionsDiv" : "BlackoutMainMenuOptionsDiv Close"} onClick={(() => {dispatch(setOpenOptionMenu(false))})}/>
            
            </div>
            {ModalDeleteCity &&
            <div
            className="ModalChangeHiddenGlobalDiv"
            >
                <div
                className="ModalChangeHiddenMainDiv"
                >
                    <div>
                    {'Филиал ' + SelectedCity.City + ' ' + SelectedCity.Adress + ' и данные о нем будут удалены без возможности восстановления' }
                    </div>
                    <div
                    className="ModalChangeHiddenButtonsDiv"
                    >
                        <button
                        className="ModalChangeHiddenButton Cancle"
                        onClick={(() => {
                            setModalDeleteCity(false)
                        })}
                        >
                            Отмена
                        </button>
                        <button
                        className="ModalChangeHiddenButton Ok"
                        onClick={handleDeleteCity}
                        >
                            Ок
                        </button>
                    </div>
                </div>
            </div>
            }

            {ModalDeleteMonth &&
            <div
            className="ModalChangeHiddenGlobalDiv"
            >
                <div
                className="ModalChangeHiddenMainDiv"
                >
                    <div>
                    {'Месяц ' + SelectedMonth.Name + ' и данные о нем будут удалены без возможности восстановления' }
                    </div>
                    <div
                    className="ModalChangeHiddenButtonsDiv"
                    >
                        <button
                        className="ModalChangeHiddenButton Cancle"
                        onClick={(() => {
                            setModalDeleteMonth(false)
                        })}
                        >
                            Отмена
                        </button>
                        <button
                        className="ModalChangeHiddenButton Ok"
                        onClick={handleDeleteMonth}
                        >
                            Ок
                        </button>
                    </div>
                </div>
            </div>
            }
        </div>
    )
}

export default MainMenu